import { InputTypes } from "./constants";
import DatePickerInput from "./DatePicker";
import RadioGroups from "./RadioGroup";
import { SelectInput } from "./Select";
import { TextInput } from "./Text";

const Input = (props) => {
  const { type = "", ...restProps } = props;

  switch (type) {
    case InputTypes.DATE_PICKER: {
      return <DatePickerInput {...restProps} />;
    }

    case InputTypes.RADIO:
      return <RadioGroups {...restProps} />;

    case InputTypes.SELECT:
      return <SelectInput {...restProps} />;

    default:
      return <TextInput {...props} />;
  }
};

export default Input;
